<template>
  <v-container :fluid="$vuetify.breakpoint.mdAndUp" class="pb-12 project-section">
    <v-row class="project-heading" align="center" justify="center" :id="projectIndex ? 'chapter-' + projectIndex : null">
      <v-col cols="8" md="10" offset-md="2" >
        <span><translate>Chapter</translate> {{chapterId}}.{{projectId}}</span>
        <h5 class="mb-2">{{data.author}}</h5>
        <h1 class="col-9 col-md-4 px-0">{{data.title}}</h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Viewport } from '@monogrid/vue-lib'

// import map from 'lodash/map'
// import ProjectImageRepeater from '@/molecules/ProjectImageRepeater'
// import ProjectTextRepeater from '@/molecules/ProjectTextRepeater'

export default {
  name: 'ChapterProjectHeading',

  mixins: [Viewport],

  components: {
    // ProjectImageRepeater,
    // ProjectTextRepeater
  },

  props: {
    data: {
      type: Object,
      required: true
    },

    chapterId: {
      type: Number,
      required: true
    },

    projectIndex: {
      type: Number,
      required: false
    }

    // subchapterId: {
    //   type: Number,
    //   required: true
    // }
  },

  data () {
    return {
      isActive: false
    }
  },

  mounted () {
    this.$events.$on('scrollto:begin', () => {
      this.isActive = true
    })
  },

  destroyed () {
    this.$events.$off('scrollto:begin')
  },

  // methods: {
  //   onIntersect (entries, observer, isIntersecting) {
  //     if (isIntersecting && this.isActive) {
  //       this.setAsCurrentProject()
  //     }
  //   },

  //   setAsCurrentProject () {
  //     if (this.subchapterId !== this.projectIndex) {
  //       this.$emit('route:update', this.projectIndex)
  //     }
  //   }
  // },

  watch: {
    isActive () {
      if (this.isActive) {
        this.setAsCurrentProject()
      }
    }
  },

  computed: {
    repeaters () {
      return this.data.content || []
    },

    projectId () {
      const pix = this.projectIndex
      return (pix < 10) ? '0' + pix : pix
    }
  }
}
</script>

<style scoped lang="scss">

.container {
  position: relative;
  top: 0;
  z-index: 1;
}

.project-heading {
  // margin: 100vh auto 0;
  height: 100vh;

  @include breakpoint('sm-and-down') {
    height: 60vh;
  }
}

span {
  font-family: Lora;
  font-size: 12px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 0.48px;
  text-align: left;
  color: $c-red;

  @include breakpoint('md-and-up') {
    font-size: 16px;
    letter-spacing: 0.96px;
  }
}

h5 {
  font-family: Lora;
  font-size: 18px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 0.48px;
  text-align: left;
  color: $c-text-grey;
  margin-bottom: -10px;

  @include breakpoint('md-and-up') {
    margin-bottom: -20px;
    font-size: 30px;
    letter-spacing: 0.96px;
  }
}

h1 {
  @include breakpoint('md-and-up') {
    font-size: 80px;
  }
}

</style>
